import $http from '@/utils/request'

const dict = {
  state: {
    customerArea: [],
    businessUsers: [],
    address: [],
    areaUnitList: [],
  },

  mutations: {
    SET_DICT(state, paylod) {
      const {key, value} = paylod
      state[key] = value
    },
    SET_PRODUCE_LOCATION(state, paylod) {
      state.areaUnitList = paylod
    },
  },

  actions: {
    setDict({commit}, type) {
      return $http.get('/system/dict/data/list', {dictType: type}).then(res => {
        commit(`SET_DICT`, {value: res.rows, key: type})
      })
    },

    // 生产单元（生产位置）信息获取，根据登录用户权限获取
    setProduceLocation({commit}, type) {
      $http.get('/api/qms/productionUnit/treeList').then(res => {
        commit(`SET_PRODUCE_LOCATION`, res.data)
      })
    },
  }
}

export default dict